import { getLocationContext } from './getLocationContext';
import { getBrowserContext } from './getBrowserContext';
import { getDeviceContext } from './getDeviceContext';
import { getOSContext } from './getOSContext';
import { getRuntimeContext } from './getRuntimeContext';

/**
 * @link https://develop.sentry.dev/sdk/data-model/event-payloads/contexts/
 * @param {Navigator} navigator
 * @returns {Object}
 */
export const getContexts = (navigator: Navigator, location: Location) => ({
  browser: getBrowserContext(navigator),
  device: getDeviceContext({
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    screen: window.screen,
    navigator,
  }),
  // capitalized to match Sentry's built-in contexts
  Location: getLocationContext(location),
  os: getOSContext(navigator),
  runtime: getRuntimeContext(navigator),
});
